import { render, staticRenderFns } from "./CustomPager.vue?vue&type=template&id=17e49c67&"
import script from "./CustomPager.vue?vue&type=script&lang=js&"
export * from "./CustomPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports